// ---------- le jeu à l'IA, côté réseau ----------
// Chaque coup part au Worker (backend/src/routes/ai.ts), qui le compte, appelle l'IA et rend
// l'état ENTIER de la partie : le jeu n'a rien à recomposer, il redessine. Derrière le jeton du
// compte anonyme (src/account.ts) — c'est lui qui porte le stock de bonus.
//
// RIEN N'EST RECOPIÉ HORS LIGNE, contrairement à src/api.ts : un coup sans réseau n'a pas de sens,
// l'IA est de l'autre côté (choix du 2026-11-04 : un niveau à l'IA est indisponible hors ligne).

import type { AiAction, AiReply } from '../shared/ai';
import { API } from './api';
import { ensureUser, forgetUser } from './account';

export class AiOffline extends Error {}

async function call(path: string, init: RequestInit = {}, retried = false): Promise<Response> {
  const token = await ensureUser();
  if (!token) throw new AiOffline();
  let res: Response;
  try {
    res = await fetch(API + path, {
      ...init,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      },
    });
  } catch {
    throw new AiOffline();
  }
  // Le compte n'existe plus (base refaite) : on en fabrique un autre, une fois.
  if (res.status === 401 && !retried) {
    forgetUser();
    return call(path, init, true);
  }
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res;
}

export const aiState = async (puzzleId: string): Promise<AiReply> =>
  (await call(`/ai/${encodeURIComponent(puzzleId)}`)).json() as Promise<AiReply>;

export const aiAct = async (puzzleId: string, action: AiAction): Promise<AiReply> =>
  (
    await call(`/ai/${encodeURIComponent(puzzleId)}`, {
      method: 'POST',
      body: JSON.stringify(action),
    })
  ).json() as Promise<AiReply>;

/** Une pub regardée : le serveur crédite (prototype : sans vérification, cf. routes/ai.ts). */
export const aiAd = async (): Promise<number> =>
  ((await (await call('/ai/wallet/ad', { method: 'POST' })).json()) as { bonus: number }).bonus;
